import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import useCart from 'services/cart/hooks/use-cart'
import { useCollection, useModelKeyName } from '@morningtrain/react-resources'
import CartContentContext from 'services/cart/contexts/CartContentContext'

function CartContent (props) {
  const cart = useCart()
  const collection = useCollection()
  const modelKeyName = useModelKeyName()

  const cartContent = observable.array()
  const tempArray = []

  if (cart && cart.size > 0) {
    for (const entry of cart.entries()) {
      const domain = collection.find(item => {
        return entry[0] === item.get(modelKeyName).toString()
      })

      if (domain) {
        domain.set('quantity', entry[1])
        domain.set('total_price', domain.get('price') * entry[1])
        domain.set('discounted_total_price', domain.get('discounted_price') * entry[1])
        tempArray.push(domain)
      }
    }
  }

  if (tempArray.length > 0) {
    cartContent.replace(tempArray)
  }

  return (
    <CartContentContext.Provider value={cartContent}>
      {props.children}
    </CartContentContext.Provider>
  )
}

export default observer(CartContent)
